module.exports = __webpack_public_path__ + "img/891.a6c1ae19.png";